import ActionsMenu from './ActionsMenu';
import './ActionsMenu.scss';
export default ActionsMenu;
